import React, { Component, Fragment } from "react";
import { Paper, TextField, withStyles, Box } from "@material-ui/core";
import { Button } from "@material-ui/core";
import Titlebar from "../shared/component/Titlebar";
import Typography from "@material-ui/core/Typography";
import AddAssetMapping from "../components/form-element/AddAssetMapping";
import FormBuilderService from "../services/form-builder.service";
import AssetMappingTable from "../components/form-element/AssetMappingTable";
import FormFillerService from "../services/review-portal-services/form-filler.service";
import { Autocomplete } from "@material-ui/lab";
import { Loader } from "../components/Loader";
import { handleSiteResponseAndSorting } from "../utility/CommonUtils";

const styles = (theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  formControl: {
    width: "400px",
    margin: "7px 0px 7px 0px",
  },
  underline: {
    "&&&:before": {
      borderBottom: "none",
    },
    "&&:after": {
      borderBottom: "none",
    },
  },
  searchLabel: {
    paddingBottom: "8px",
  },
});

class AssetProfiling extends Component {
  constructor() {
    super();
    this.state = {
      sites: [],
      sitesOptionList: [],
      showDialog: false,
      selectedSite: "",
      selectedSiteId: "",
      showTable: false,
      showMessage: false,
      filteredData: [],
      isLoading: false,
      inputValue: "",
      turbineData: [],
      page: 0,
      rowsPerPage: 20,
    };
    this.formBuilderService = new FormBuilderService();
    this.formFillerService = new FormFillerService();
  }

  componentDidMount() {
    this.formFillerService.getAllSites().then((response) => {
      this.setState({
        sites: response,
        sitesOptionList: handleSiteResponseAndSorting(response),
      });
    });
  }

  filterOptions = () => {
    const searchTerm = this.state.inputValue.toLowerCase().trim();
    if (!this.state.turbineData) {
      this.setState({ filteredData: [] });
      return;
    }
    const filteredOptions = this.state.turbineData.filter((option) => {
      const turbineId = option?.turbineId?.toString()?.toLowerCase() || "";
      const shortName = option?.shortName?.toLowerCase() || "";
      const equipmentName = option?.optionalEquipmentName?.toLowerCase() || "";
      if (
        turbineId.includes(searchTerm) ||
        shortName.includes(searchTerm) ||
        equipmentName.includes(searchTerm)
      ) {
        return true;
      }
      if (searchTerm.includes("|")) {
        const parts = searchTerm
          .split("|")
          .map((p) => p.trim())
          .filter((p) => p);
        return parts.every(
          (part) => turbineId.includes(part) || shortName.includes(part),
        );
      }

      return false;
    });

    this.setState({ filteredData: filteredOptions });
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevState.inputValue !== this.state.inputValue) {
      this.filterOptions();
    }
  }

  handleChangePage = (newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10) });
    this.setState({ page: 0 });
  };

  onRowsDelete = () => this.setState({ page: 0 });

  handleInputChange = (event, newInputValue, reason) => {
    this.setState({ page: 0 });
    if (reason === "clear") {
      this.setState({ inputValue: "" });
    } else if (reason === "input") {
      this.setState({ inputValue: newInputValue });
    }
  };

  onChangeSite = (_event, value) => {
    this.setState({ isLoading: true, inputValue: "" });
    if (value) {
      let siteId = value.id;
      this.formBuilderService
        .getOptionalEquipmentMapping(siteId)
        .then((response) => {
          this.setState({
            filteredData: response.data,
            isLoading: false,
            showTable: true,
            showMessage: true,
            turbineData: response.data,
          });
        });
      this.setState({
        selectedSite: this.state.sites.find((val) => val.siteId === value.id),
        selectedSiteId: value.id,
      });
    } else {
      this.setState({
        filteredData: [],
        isLoading: false,
        showTable: true,
        showMessage: false,
        turbineData: [],
        selectedSite: "",
      });
    }
  };

  addMadpping = () => {
    this.setState({
      showDialog: true,
    });
  };

  handleClose = () => {
    this.setState({
      showDialog: false,
    });
  };

  onEnterSearch = (event) => {
    if (event.key === "Enter") {
      event.stopPropagation();
    }
  };

  updateFilteredData = (newArray) => {
    if (newArray.length) {
      this.setState({
        filteredData: newArray,
        turbineData: newArray,
        showMessage: true,
      });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <Titlebar title={"Asset Profiling"}>
          <Button
            variant="contained"
            onClick={this.addMadpping}
            color="primary"
            disableElevation
          >
            Add Mapping
          </Button>
        </Titlebar>
        <Paper className={classes.root} component={"div"} elevation={0}>
          <Typography className={classes.searchLabel} variant="h6">
            Search
          </Typography>
          <Box display="flex">
            <Autocomplete
              id="siteSearchId"
              options={this.state.sitesOptionList}
              freeSolo
              disableCloseOnSelect
              getOptionLabel={(option) => option.label}
              getOptionSelected={(option, value) => option.id === value.id}
              onChange={this.onChangeSite}
              style={{ width: "30%", marginRight: "24px" }}
              renderOption={(option) => (
                <React.Fragment>{option.label}</React.Fragment>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  id="SitesTextField"
                  variant="outlined"
                  label="Select Sites"
                  onKeyDown={this.onEnterSearch}
                />
              )}
            />
            {this.state.selectedSite && (
              <Autocomplete
                id="turbineSearchId"
                options={[]}
                freeSolo
                inputValue={this.state.inputValue}
                style={{ width: "30%" }}
                disableOpenOnFocus
                disabled={
                  !this.state.turbineData ||
                  this.state.turbineData.length === 0
                }
                onInputChange={this.handleInputChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    id="TurbineTextField"
                    variant="outlined"
                    label="Search by Turbine or Optional Equipment"
                    onKeyDown={this.onEnterSearch}
                  />
                )}
              />
            )}
          </Box>
          <div>
            <Loader position="center" loading={this.state.isLoading} />
          </div>
          {this.state.showTable && !this.state.isLoading ? (
            <AssetMappingTable
              filteredData={this.state.filteredData}
              showMessage={this.state.showMessage}
              selectedSiteId={this.state.selectedSiteId}
              page={this.state.page}
              rowsPerPage={this.state.rowsPerPage}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              onRowsDelete={this.onRowsDelete}
            />
          ) : null}
        </Paper>
        {this.state.showDialog ? (
          <AddAssetMapping
            open={this.state.showDialog}
            title="Optional Equipment Mapping"
            selectedSite={this.state.selectedSite}
            selectedSiteId={this.state.selectedSiteId}
            updateFilteredData={this.updateFilteredData}
            onClose={this.handleClose}
          />
        ) : null}
      </Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(AssetProfiling);
